module.exports = __webpack_public_path__ + "static/img/benefit_mb3.48b398c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingPage/bussiness/benefit_mb3.png
// module id = YRdY
// module chunks = 30